import {getToken} from '../actions/utils';

export function info() {
  const url = '/api/subscriptions/info';
  const headers = {'Content-Type': 'application/json', token: getToken()};

  return fetch(url, {headers}).then(res => res.json());
}
